import { PersonLabelFragment } from "gql/graphql";
import { Hidable, Value } from "@/shared/value";
import { PersonLabelView } from "../views/person-label-view";
import { ReactNode } from "react";

export type PersonProps = {
  data?: Hidable<PersonLabelFragment>;
  size?: "small" | "default" | "large";
  extra?: ReactNode;
};

export function PersonLabel({ data, size, extra }: PersonProps) {
  return (
    <Value data={data}>
      {(person) => <PersonLabelView data={person} size={size} extra={extra} />}
    </Value>
  );
}
